import { Table } from "@material-ui/core";
import React from "react";

import useStyles from "../useStyles";

import RegisterTableBody from "./RegisterTableBody";
import RegisterTableHead from "./RegisterTableHead";

/**
 * RegisterTableコンポーネント.
 *
 * @return {object} コンポーネント
 */
function RegisterTable() {
  // スタイル
  const styles = useStyles();

  return (
    <Table className={styles.registerTable}>
      <RegisterTableHead />
      <RegisterTableBody />
    </Table>
  );
}

export default RegisterTable;
